import _ from 'underscore';
import preferencesService from '@bingads-webui-component-legacy/preference/service/index';

//Adding instrumentation to log additional information for cachemiss sorting issue.
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

export function handleSortChange(changes, view, sortInfoKey) {
  if (_.has(changes, 'sortableHeader')) {
    const orderby = _.result(changes.query, 'orderby') ||
      _.result(view.get('query'), 'orderby') ||
      _.chain(view)
        .result('dataSource')
        .result('dataSource')
        .result('orderby')
        .value();
    const sortableHeader = changes.sortableHeader;
    const preference = { sortInfo: { orderby, sortableHeader } };

    // Remove once cachemiss sorting issue is fixed.
    const isDataFetchManagerEnabled = view.get('isDataFetchManagerSource');

    if (!orderby && isDataFetchManagerEnabled === true) {
      const currentsortableHeader = changes.sortableHeader;
      const currentQuery = _.omit(_.result(changes, 'query'), 'options');
      const queryFromView = _.omit(view.get('query'), 'options');

      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'cachemiss-handleSortChange', JSON.stringify({ currentQuery, queryFromView, currentsortableHeader}));
    }

    const UIGrids = ['PerformanceGrid', 'summary_tab_campaign', 'summary_tab_ad_group', 'summary_tab_ad'];
    const isUIGrid = UIGrids.includes(sortInfoKey);

    // TODO: investigate why handleSortChange gets called automatically when redirecting to Ad groups page
    if (isUIGrid) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'grid-column-sort', JSON.stringify({sortInfoKey, sortableHeader}));
    }
    preferencesService.setAtUserLevel({ Name: `WebApp.CampaignUI.${sortInfoKey}`, Data: preference });
  }
}
